// Products.jsx
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";

// Product Data Structure
const productsData = {
  injectable: [
    { id: 1, name: "BOLDA 300", image: "/assets/products/injectables/bolda.jpg", pack: "10 ml vial (100 mg/ml)", price: "£89.99" },
    { id: 2, name: "TEST-E 300", image: "/assets/products/injectables/teste.jpg", pack: "10 ml vial (100 mg/ml)", price: "£79.99" },
    { id: 3, name: "DECA 350", image: "/assets/products/injectables/deca.jpg", pack: "10 ml vial (250 mg/ml)", price: "£99.99" },
    { id: 4, name: "NPP 100", image: "/assets/products/injectables/npp.JPG", pack: "10 ml vial (250 mg/ml)", price: "£109.99" },
    { id: 5, name: "TEST-C 300", image: "/assets/products/injectables/testc.JPG", pack: "10 ml vial (250 mg/ml)", price: "£119.99" },
    { id: 6, name: "TREN-A 100", image: "/assets/products/injectables/trena.jpg", pack: "10 ml vial (400 mg/ml)", price: "£139.99" },
    { id: 7, name: "PRIMO 100", image: "/assets/products/injectables/primo.JPG", pack: "10 ml vial (100 mg/ml)", price: "£129.99" },
    { id: 8, name: "SUSTANON 400", image: "/assets/products/injectables/sustanon.jpg", pack: "10 ml vial (100 mg/ml)", price: "£129.99" },
    { id: 9, name: "WINSTROL 100", image: "/assets/products/injectables/winstrol.jpg", pack: "10 ml vial (200 mg/ml)", price: "£149.99" },
    { id: 10, name: "MASTERON 100", image: "/assets/products/injectables/masteron.JPG", pack: "10 ml vial (250 mg/ml)", price: "£94.99" },
    { id: 11, name: "TEST-P 100", image: "/assets/products/injectables/testp.JPG", pack: "10 ml vial (250 mg/ml)", price: "£89.99" },
    { id: 12, name: "TREN-E 200", image: "/assets/products/injectables/trene.jpg", pack: "10 ml vial (100 mg/ml)", price: "£134.99" },
],
  oral: [
  {
    id: 25,
    name: "ANADROL 50MG",
    manufacturer: "Anabolic Pharma",
    image: "/assets/products/orals/anadrol.png",
    pack: "100 tabs bottle",
    price: "£69.99"
  },
  {
    id: 26,
    name: "ANAVAR 10MG",
    manufacturer: "Anabolic Pharma",
    image: "/assets/products/orals/anavar.png",
    pack: "100 tabs bottle",
    price: "£59.99"
  },
  {
    id: 27,
    name: "CLEN 40MCG",
    manufacturer: "Anabolic Pharma",
    image: "/assets/products/orals/clen.png",
    pack: "100 tabs bottle",
    price: "£79.99"
  },
  {
    id: 28,
    name: "DBOL 10MG",
    manufacturer: "Anabolic Pharma",
    image: "/assets/products/orals/dbol.png",
    pack: "100 tabs bottle",
    price: "£89.99"
  },
  {
    id: 29,
    name: "STANA 10MG",
    manufacturer: "Anabolic Pharma",
    image: "/assets/products/orals/stana.png",
    pack: "100 tabs bottle",
    price: "£59.99"
  },
  {
    id: 30,
    name: "T3 40MCG",
    manufacturer: "Anabolic Pharma",
    image: "/assets/products/orals/t3.png",
    pack: "100 tabs bottle",
    price: "£149.99"
  }
]
};

export default function Products() {
  const [activeCategory, setActiveCategory] = useState("injectable");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("default");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Get current products based on category
  const currentProducts = productsData[activeCategory] || [];

  // Filter and sort products
  const filteredProducts = currentProducts
    .filter(product => 
      product.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (sortBy === "price-low") {
        return parseFloat(a.price.replace('$', '')) - parseFloat(b.price.replace('$', ''));
      } else if (sortBy === "price-high") {
        return parseFloat(b.price.replace('$', '')) - parseFloat(a.price.replace('$', ''));
      } else if (sortBy === "name") {
        return a.name.localeCompare(b.name);
      }
      return 0;
    });

  // Close sidebar on window resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);

    // set the pointer to top of the page
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="fixed-box min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4 py-8">
        
        {/* Breadcrumb */}
        <div className="products-list-breadcrumb mb-6 text-sm">
          <nav className="flex items-center space-x-2 text-gray-600 dark:text-gray-400">
            <Link to="/" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
              Home
            </Link>
            <span>/</span>
            <span className="text-gray-900 dark:text-white font-semibold">Products</span>
          </nav>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          
          {/* Sidebar for Mobile Toggle */}
          <div className="lg:hidden mb-4">
            <button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="w-full px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg flex items-center justify-center space-x-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              <span>Categories</span>
            </button>
          </div>

          {/* Sidebar Navigation */}
          <aside className={`
            ${isSidebarOpen ? 'fixed inset-0 z-50 bg-white dark:bg-gray-900 p-6 overflow-y-auto' : 'hidden'}
            lg:block lg:relative lg:bg-transparent lg:p-0 lg:w-80
          `}>
            {isSidebarOpen && (
              <button
                onClick={() => setIsSidebarOpen(false)}
                className="lg:hidden absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
            
            <div className="prodcuts-navbar space-y-6">
              {/* Injectable Steroids Category */}
              <div className="prodcuts-navbar-nav bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="prodcuts-navbar-nav-bar bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 font-bold text-lg">
                  INJECTABLE STEROIDS
                </div>
                <ul className="prodcuts-navbar-nav-items max-h-96 overflow-y-auto">
                  {productsData.injectable.map(product => (
                    <li key={product.id}>
                      <button
                        onClick={() => {
                          setActiveCategory("injectable");
                          setSearchTerm(product.name);
                          setIsSidebarOpen(false);
                        }}
                        className="w-full text-left px-6 py-2 text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-gray-700 hover:text-blue-600 dark:hover:text-blue-400 transition-all duration-200 text-sm"
                      >
                        {product.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Oral Steroids Category */}
              <div className="prodcuts-navbar-nav bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="prodcuts-navbar-nav-bar bg-gradient-to-r from-green-600 to-teal-600 text-white px-6 py-3 font-bold text-lg">
                  ORAL STEROIDS
                </div>
                <ul className="prodcuts-navbar-nav-items max-h-96 overflow-y-auto">
                  {productsData.oral.map(product => (
                    <li key={product.id}>
                      <button
                        onClick={() => {
                          setActiveCategory("oral");
                          setSearchTerm(product.name);
                          setIsSidebarOpen(false);
                        }}
                        className="w-full text-left px-6 py-2 text-gray-700 dark:text-gray-300 hover:bg-green-50 dark:hover:bg-gray-700 hover:text-green-600 dark:hover:text-green-400 transition-all duration-200 text-sm"
                      >
                        {product.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </aside>

          {/* Products Grid Section */}
          <section className="products-list flex-1">
            {/* Category Header and Controls */}
            <div className="mb-6 bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6">
              <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                <div>
                  <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    {activeCategory === "injectable" ? "Injectable Steroids" : "Oral Steroids"}
                  </h2>
                  <p className="text-gray-600 dark:text-gray-400 text-sm mt-1">
                    {filteredProducts.length} products available
                  </p>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                  {/* Search Bar */}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search products..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="px-4 py-2 pl-10 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:border-blue-500 dark:bg-gray-700 dark:text-white w-full sm:w-64"
                    />
                    <svg className="absolute left-3 top-2.5 w -4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>

                  {/* Sort Dropdown */}
                  <select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    className="px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                  >
                    <option value="default">Sort by: Default</option>
                    <option value="name">Sort by: Name</option>
                    <option value="price-low">Sort by: Price (Low to High)</option>
                    <option value="price-high">Sort by: Price (High to Low)</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Category Tabs */}
            <div className="flex gap-2 mb-6">
              <button
                onClick={() => {
                  setActiveCategory("injectable");
                  setSearchTerm("");
                }}
                className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 ${
                  activeCategory === "injectable"
                    ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg"
                    : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:shadow-md"
                }`}
              >
                Injectable
              </button>
              <button
                onClick={() => {
                  setActiveCategory("oral");
                  setSearchTerm("");
                }}
                className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 ${
                  activeCategory === "oral"
                    ? "bg-gradient-to-r from-green-600 to-teal-600 text-white shadow-lg"
                    : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:shadow-md"
                }`}
              >
                Oral
              </button>
            </div>

            {/* Products Grid */}
            {filteredProducts.length > 0 ? (
              <div className="products-list-body grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {filteredProducts.map((product) => (
                  <ProductCard key={product.id} product={product} />
                ))}
              </div>
            ) : (
              <div className="text-center py-12 bg-white dark:bg-gray-800 rounded-xl">
                <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="text-gray-500 dark:text-gray-400 text-lg">No products found</p>
                <button
                  onClick={() => setSearchTerm("")}
                  className="mt-4 text-blue-600 hover:text-blue-700 font-semibold"
                >
                  Clear search
                </button>
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}